import { Box, Button, Layer, Text } from 'grommet';
import React from 'react';
import { t } from 'i18next';

interface UnenrollModalProps {
  hideModal: () => void;
  handleSubmit: (event: any) => void;
}

export const UnenrollModal: React.FC<UnenrollModalProps> = ({ hideModal, handleSubmit }) => {
  const btnStyle = { padding: '8px 18px', justifyContent: 'center', alignItems: 'center', fontWeight: 900, fontSize: '16px', flexGrow: 1 };
  return (
    <Layer style={{ border: '1px solid #CCCCCC', borderRadius: '12px' }} onEsc={hideModal} onClickOutside={hideModal}>
      <Box alignSelf={'center'} align={'center'} pad={'24px'} gap={'24px'} width={'400px'} data-cy={'unenroll-modal'}>
        <Box alignSelf={'center'} align={'center'} gap={'8px'}>
          <Text style={{ fontSize: '16px', fontWeight: '900' }} alignSelf='center'>
            {t('fieldFlow.mainWizard.Fields.unenrollModal.title')}
          </Text>
          <Text style={{ fontSize: '12px', fontWeight: '400', textAlign: 'center' }}>{t('fieldFlow.mainWizard.Fields.unenrollModal.content')}</Text>
        </Box>
        <Box width={'100%'} direction={'row'} gap={'12px'}>
          <Button
            plain
            data-cy={'unenroll-modal-cancel'}
            label={t('fieldFlow.mainWizard.Fields.unenrollModal.cancelButton')}
            onClick={hideModal}
            className={'secondary-button'}
            style={{ ...btnStyle, border: '1px solid #282828', textAlign: 'center' }}
          />
          <Button
            plain
            data-cy={'unenroll-modal-confirm'}
            id={'resubmit-contract'}
            type='submit'
            label={t('fieldFlow.mainWizard.Fields.unenrollModal.confirmButton')}
            onClick={handleSubmit}
            className={'primary-button'}
            style={{ ...btnStyle, background: '#D03450', color: 'white', textAlign: 'center' }}
          />
        </Box>
      </Box>
    </Layer>
  );
};
